const API_BASE_URL = 'https://usefullsofware.com/visioner7_api_services/v1/dxn/';

export const centroServicioService = {
    async obtenerCentros() {
        try {
            const token = localStorage.getItem('auth_token');
            
            if (!token) {
                return { success: false, error: 'No hay sesión activa.', code: 401 };
            }

            const response = await fetch(`${API_BASE_URL}productos/centros_servicio_listar.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({ token: token })
            });

            if (!response.ok) {
                if (response.status === 401 || response.status === 403) {
                    return { success: false, error: 'Sesión expirada o permisos insuficientes.', code: response.status };
                }
                throw new Error(`Error HTTP: ${response.status}`);
            }

            const data = await response.json();

            if (data.server_mensaje && data.server_mensaje.ESTADO === 1) {
                return { success: true, data: data.data || [], mensaje: data.server_mensaje.MENSAJE };
            } else {
                return { success: false, error: data.server_mensaje?.MENSAJE || 'Error al obtener los centros.', code: 400 };
            }
        } catch (error) {
            console.error('Error en centroServicioService:', error);
            return { success: false, error: 'Error de conexión con el servidor.', code: 500 };
        }
    }
};